import { getBooks } from "features/CategoryNews/services/book.service";
import { searchEngineCounts } from "config";

const createBooksAdapter = ({ searchContext }) => {
  const { currentSearchTerm } = searchContext;

  const pageSize = searchEngineCounts["Books"];
  const enabled = Boolean(currentSearchTerm);
  const dependencies = [currentSearchTerm];

  const fetchPage = async (cursor) => {
    if (!enabled) return { items: [], nextCursor: cursor, hasMore: false };
    const data = await getBooks(currentSearchTerm, cursor, pageSize);
    const items = data?.data || [];
    const nextCursor = cursor + pageSize;
    const hasMore = items.length > 0;
    return { items, nextCursor, hasMore };
  };

  return {
    idKey: "infoLink",
    initialCursor: 0,
    fetchPage,
    dependencies,
    enabled,
    isPageMode: false,
  };
};

export default createBooksAdapter;


